import React from 'react'
import Menu from './Menu.js'
import Grid from "@material-ui/core/Grid";
import '../assets/css/Order.css'
import '../assets/css/Transaction.css'
import TransactionTable from '../components/Table/TransactionTable.js'
import { withStyles } from '@material-ui/core';

const styles = theme => ({
    margin: {
          // margin: theme.spacing(1),
          marginTop: theme.spacing(1),
          marginLeft: theme.spacing(1)
        
      },
      textSearch: {
        fontSize: '24px',
        fontFamily: 'Roboto-Light',
        color: '#333333',
        marginTop: theme.spacing(1.5),
        [theme.breakpoints.down('md')]: {
            fontSize: '24px',
            marginTop: theme.spacing(1.6)
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
            marginTop: theme.spacing(1.5)
        },
    },
   });
class OpenOrders extends React.Component {
    render(){
        return (
            <div style={{backgroundColor:'white'}}>
                 <div>
                    <Grid container>
                        <Grid item xs={12}>
                            <Menu />
                        </Grid>
                    </Grid>
                </div>
                <div className="mdata">
                    <Grid container >
                        <Grid item xs={12}>
                            <h2 className="mtextOpenOrder">
                                Transactions
                            </h2>
                        </Grid>
                    </Grid>
                    <TransactionTable />
                </div> 
            
            </div>
        )
    }
    
}

export default withStyles(styles) (OpenOrders);